<template>
  <div id="top-reviews-widget" :class="{'is-visible': isFreeSubscriptionActive}">
    <template v-if="!isFreeSubscriptionActive || isFreeSubscriptionActive && isBlueBlockActive">
      <p class="has-text-weight-bold is-size-5">What our customers say:</p>
      <a :href="externalUrl(record.permalink)" target="_blank" class="review-block"
         :class="[{'disable-link': clickLink}]" v-for="record in reviewList">
        <div class="columns is-mobile">
          <div class="column is-one-third">
            <rating :stars="record.review_rating" :reviews-widget="tinyStars"></rating>
          </div>
          <div class="column"><p class="has-text-right"><span v-text="record.author"></span>&nbsp;|&nbsp;{{
            record.created_date | reviewDate }}</p></div>
        </div>
        <div class="columns">
          <div class="column">
            <h4 class="has-text-weight-bold" v-text="record.review_title"></h4>
            <p>{{ record.review_content | snippetCopy }}</p>
          </div>
        </div>
      </a>
      <img v-if="fetching" class="loader" src="/static/img/spinner.svg" alt="fetching top reviews..."/>
      <img src="/static/img/widgets/powered-by-hp.png" srcset="/static/img/widgets/powered-by-hp@2x.png 2x"/>
    </template>
    <template v-else></template>
  </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef */
  import Rating from './../components/Rating.vue'
  import ReviewsWidgetMixin from './../mixins/reviews-widget.js'
  import misc from './../mixins/misc.js'

  export default {
    name: 'TopReviewsVertical',
    props: {
      slug: {
        type: String
      },
      clickLink: {
        type: Boolean,
        default: true
      }
    },
    mixins: [ReviewsWidgetMixin, misc],
    components: {
      Rating
    },
    created () {
      this.getReviewFeed()
      this.getCurrentBusinessActiveSubscription()
    },
    filters: {
      /**
       * copy text to clipboard
       * @param {string} text string to be copy
       * @return {string|*}
       */
      snippetCopy (text) {
        if (text.length > 199) {
          return text.substring(0, 200).trim() + '...'
        }
        return text
      }
    }
  }
</script>
<style scoped>
  #top-reviews-widget {
    width: 360px;
    background: #fff;
    padding: 17px 20px 20px 20px;

  }

  .disable-link {
    pointer-events: none;
  }

  #top-reviews-widget > p:first-child {
    margin-bottom: 0;
    padding-bottom: 1rem;
    border-bottom: 1px solid #DFDFE0;
  }

  #top-reviews-widget > a {
    text-decoration: none;
    color: #58595B;
    border-bottom: 1px solid #DFDFE0;
    display: block;
    padding-top: 1.6rem;
    padding-bottom: 1.6rem;
  }

  #top-reviews-widget > a:first-child {
    border: none;
    padding-top: 0;
  }

  #top-reviews-widget > a > .columns:first-child > .column > p {
    color: #8A8C91;
    font-size: 0.7rem;
  }

  #top-reviews-widget h4 {
    font-size: 1rem;
    margin-bottom: 0.4rem;
  }

  #top-reviews-widget > a > .columns:not(:first-child) > .column > p {
    font-size: 0.8rem;
  }

  .review-block > .columns:first-child {
    margin-bottom: 0;
  }

  #top-reviews-widget img {
    display: block;
    width: 156px;
    height: 20px;
    margin-top: 1.6rem;
    margin-bottom: 1.6rem;
  }

  #top-reviews-widget span {
    font-weight: bold;
  }

  #top-reviews-widget img.loader {
    width: 40px;
    height: 40px;
    float: none;
    display: block;
    margin: 1.6rem auto;
    border: none;
  }

  .is-visible {
    background: rgb(49, 170, 225);
    height: 707px;
  }

  #top-reviews-widget .column .has-text-weight-bold {
    font-size: 13px !important;
  }

  #top-reviews-widget > a {
    padding-top: 13px !important;
  }

  #top-reviews-widget .is-mobile div {
    padding-left: 12px;
    padding-left: 0px;
    padding-right: 0px;
    width: auto !important;
    padding: 3px 19px 4px 13px;
  }

  #top-reviews-widget .is-mobile div {
    padding-left: 0px;
    padding-right: 0px;
    width: auto !important;
  }
</style>



// WEBPACK FOOTER //
// src/widgets/TopReviewsVertical.vue